/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useContext, useEffect, useRef } from 'react';
import moment from 'moment';
import _ from 'lodash-es';
import { useIntl } from 'react-intl';
import { useTheme } from '@material-ui/core/styles';
import {
  DialogBox,
  Watermark,
  WidgetHeader,
  DocLinkWidgetWrapper,
  DocLinkWidgetScroll,
  THEME,
  NUM_OPEN_WIDGET,
  PATIENT_HEADER_HEIGHT,
  ReactPDFWrapper,
} from '@mummssoftware/common-ui';
import { Responsive, WidthProvider } from 'react-grid-layout';
import type { Layout, Layouts } from 'react-grid-layout';
import Bereavement from '@mummssoftware/bereavement';
import ClearScripts from '@mummssoftware/clearscripts';
import CarePlanFrequency from '@mummssoftware/care-plan-frequency';
import CarePlanProblems from '@mummssoftware/care-plan-problems';
import CompletedForms from '@mummssoftware/completed-forms';
import CertApp from '@mummssoftware/cert-app';
import Facesheet from '@mummssoftware/facesheet';
import Forms from '@mummssoftware/forms';
import HospiceItemSet from '@mummssoftware/hospice-item-set';
import IDGDocument, { CrossPatientIDG } from '@mummssoftware/idg-document';
import Manifest from '@mummssoftware/manifest';
import Hope from '@mummssoftware/hope';
import Measures from '@mummssoftware/measures';
import Orders from '@mummssoftware/orders';
import PatientAssistance from '@mummssoftware/patient-assistance';
import ProgressNotes from '@mummssoftware/progressnotes';
import PortalPrint from '@mummssoftware/portal-print';
import IncidentsWidget from '@mummssoftware/incidents';
import ScheduledVisits, {
  CrossPatientCompliance,
} from '@mummssoftware/scheduled-visits';
import VisitLog from '@mummssoftware/visit-log';
import FaxLog from '@mummssoftware/fax-log';
import MaiaChatAgent from '@mummssoftware/maia-chat-agent';
import VisitSummary from '@mummssoftware/visit-summary';
import ReportsList from '@mummssoftware/reports-list';
import { Pim } from '@mummssoftware/utils';
import PatientsListing from '@mummssoftware/patients-listing';
import {
  GlobalContext,
  OPEN_WIDGET,
  CLOSE_WIDGET,
  REFRESH_PN_WIDGET,
  SET_WIDGET_NAMES_OPEN,
  refreshGlobalPatientHeader,
} from '@mummssoftware/global-context/GlobalContext';
import {
  HopeGlobalContext,
  CertGlobalContext,
  PNGlobalContext,
} from '@mummssoftware/global-context';
import { IDGGlobalContext } from '@mummssoftware/idg';

import {
  Measures as MeasuresWidget,
  ClearScripts as ClearScriptsWidget,
  DocLink as DocLinkWidget,
  CarePlanFrequency as CarePlanFrequencyWidget,
  HospiceItemSet as HospiceItemSetWidget,
  ProgressNotes as ProgressNotesWidget,
  CarePlanProblems as CarePlanProblemsWidget,
  print,
  DocLink,
  STRING_TRUE,
} from '@mummssoftware/utils/constants';
import {
  MummsPDFGlobalContext,
  SET_PDF_CERT_APP_SNAPSHOT,
} from '@mummssoftware/mumms-print';

import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import { ComponentMap } from '../Context/types';
import { DocLinkBody, WidgetModal, ModalDiv } from '../../components';
import { DashboardContext } from '../Context/contexts/DashboardContext';
import { Context } from '../../context';
import {
  idgMeetingName,
  ADD_WIDGET_READY,
  SET_DASHBOARD_READY,
  SET_PRINT_INTERFACE_OPEN,
} from '../Context/constants';

import './style/style.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const ResponsiveGridLayout = WidthProvider(Responsive);

const DEFAULT_GRID_W = 2;
const DEFAULT_GRID_H = 2;

type DashboardProps = {
  config: mumms.WidgetConfig[];
  currentUser: mumms.User;
  keycloak: Keycloak.KeycloakInstance;
  patient?: mumms.patient;
  pim: Pim;
  topBarHeight: number;
  logout?: () => void;
  dashboardPrintConfig: mumms.PrintConfigInterface | null;
  printConfigNames: Record<mumms.ComponentName, string>;
  onRemovePatientDashboardWidget?: (widget: mumms.WidgetConfig) => void;
  hydrateInProgressVisitFromLog?: (
    pimreaderVisit: any,
    pimPatientVisitDto: any,
    hopeReopenWorkflowMilestone?: string,
  ) => void;
  hydrateDocumentVisitFromLog?: (
    pimreaderVisit: any,
    pimPatientVisitDto: any,
  ) => void;
  setReopenVisitDashboardLoader?: (show: boolean) => void;
};

export const DashboardGridComponent = ({
  config,
  pim,
  keycloak,
  currentUser,
  patient,
  topBarHeight,
  logout,
  dashboardPrintConfig,
  printConfigNames,
  onRemovePatientDashboardWidget,
  hydrateInProgressVisitFromLog,
  hydrateDocumentVisitFromLog,
  setReopenVisitDashboardLoader,
}: DashboardProps) => {
  const {
    props: {
      dashboard: { widget1by1Height },
    },
  } = useTheme() as any;
  // TODO listen to dispatch with a useEffect useContext
  const theme = localStorage.getItem(THEME);
  const intl = useIntl();

  const patientNumber = patient && patient.patientNumber;

  let gridConfig = _.cloneDeep(config);
  const { agency, siteId, visitAttributes, idgMeeting } = useContext(Context);
  const isIDGMeeting = idgMeeting?.idgMeetingID;
  // idgFilter can be true from URL idgmeeting while Context.idgMeeting.idgMeetingID is
  // still null (missing from/to or context not fully IDG-scoped). Use URL param as fallback
  // so entityKey is -1_<id> not -1_null.
  const urlIdgMeetingId = new URLSearchParams(window.location.search).get(
    'idgmeeting',
  );
  const idgMeetingId = isIDGMeeting || urlIdgMeetingId || null;

  if (isIDGMeeting) {
    gridConfig = gridConfig
      .filter((w: mumms.WidgetConfig) => w.idgConfig)
      .map((w: mumms.WidgetConfig) => ({
        ...w,
        widgetMenuOrder:
          w.idgConfig?.order != null && w.idgConfig.order !== ''
            ? Number(w.idgConfig.order)
            : null,
      }));
  }

  const gridConfigSyncKey = gridConfig
    .map(
      (w: mumms.WidgetConfig) =>
        `${w.componentName ?? ''}:${w.widgetMenuOrder ?? ''}`,
    )
    .join('|');

  const [widgetsConfig, setWidgetConfig] = useState<any>(gridConfig);

  useEffect(() => {
    setWidgetConfig(_.cloneDeep(gridConfig));
    // Re-sync when the dashboard widget set/order from props changes (e.g. patient
    // dashboard "add widget"); `config` is often a new reference each parent render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridConfigSyncKey]);
  const widgetsConfigName =
    widgetsConfig && widgetsConfig.map((x: any) => x.componentName);

  const { refreshDashboard, database, widgetsReady, dispatch } = useContext(
    DashboardContext,
  );

  const { idgContent } = useContext(IDGGlobalContext);

  const globalContext = useContext(GlobalContext);
  const {
    widgetsOpen,
    widgetNamesOpen,
    widgetsFilter,
    refreshPN,
    reloadManifest,
    reloadMesures,
  } = useContext(GlobalContext);

  const { includePdfCertApp, dispatchReactPDF } = useContext(
    MummsPDFGlobalContext,
  );
  const { patientCertHistory } = useContext(CertGlobalContext);
  const { admitHopePatient } = useContext(HopeGlobalContext);
  const { idgFilter } = useContext(PNGlobalContext);

  const idgReviewComplete = idgContent && idgContent.idgNarratives;
  const idgReviewCompleteRef = useRef(false);
  const numOpenWidgets =
    widgetsOpen.length > 4 ? 4 : widgetsOpen.length > 2 ? 2.1 : 1;

  localStorage.setItem(NUM_OPEN_WIDGET, numOpenWidgets.toString());

  const patientHeaderHeight =
    (document &&
      document.getElementById('patientHeader') &&
      document.getElementById('patientHeader')?.clientHeight) ||
    0;
  localStorage.setItem(PATIENT_HEADER_HEIGHT, patientHeaderHeight.toString());

  if (idgReviewComplete) {
    setTimeout(() => {
      idgReviewCompleteRef.current = true;
    }, 2000);
  }
  const isWidgetOpen = !!widgetsOpen.length;

  const openPrintInterface = () =>
    dispatch({
      type: SET_PRINT_INTERFACE_OPEN,
      payload: true,
    });

  const [key, setKey] = useState<string>('widgetKey');

  // all widget that need to be refreshed upon closing the widget
  const [refreshCert, setRefreshCert] = useState<number>(0);
  const [refreshVisit, setRefreshVisit] = useState<number>(0);
  const [refreshMeasure, setRefreshMeasures] = useState<number>(0);
  const [refreshMeds, setRefreshMeds] = useState<number>(0);
  const [refreshHIS, setRefreshHIS] = useState<number>(0);
  const [refreshPlans, setRefreshPlans] = useState<number>(0);
  const [refreshNotes, setRefreshNotes] = useState<number>(0);
  const [loadErrorTimer, setLoadErrorTimer] = useState<number | null>(null);

  useEffect(() => {
    // after 12 seconds stop the loader
    const timeoutInterval = 12000;
    const loadErrorTimerID = window.setTimeout(() => {
      dispatch({ type: SET_DASHBOARD_READY, payload: true });
    }, timeoutInterval);
    // save the print timeout ID
    setLoadErrorTimer(loadErrorTimerID);
  }, []);

  useEffect(() => {
    // no widgets
    // if visit is opened should take visit API calls in account
    // not possible scenario no widget
    if (!widgetsConfigName.length) {
      setTimeout(() => {
        dispatch({ type: SET_DASHBOARD_READY, payload: true });
        clearTimeout(loadErrorTimer as number);
      }, 1000);
    }
    if (widgetsReady.length) {
      if (widgetsReady.length === widgetsConfigName.length) {
        setTimeout(() => {
          dispatch({ type: SET_DASHBOARD_READY, payload: true });
          clearTimeout(loadErrorTimer as number);
        }, 500);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetsReady.length]);

  /**
   * refresh widget keys
   */
  useEffect(() => {
    if (refreshDashboard > 0) {
      setKey(`refreshWidgetKey${refreshDashboard}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshDashboard]);
  /**
   * refresh MEASURES
   */
  useEffect(() => {
    if (reloadMesures > 0) {
      setRefreshMeasures(refreshMeasure + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadMesures]);

  useEffect(() => {
    // if closing the window then refresh the screen with the changes that may have affected the opened widget
    // strategy is change the key of the opened widget, upon closing reset the key and refresh the screen
    if (!isWidgetOpen && widgetNamesOpen.length) {
      const newConfig = _.cloneDeep(widgetsConfig.slice());
      setWidgetConfig(newConfig);
      // clear the open widget names
      setTimeout(
        () =>
          globalContext.dispatch({
            type: SET_WIDGET_NAMES_OPEN,
          }),
        1000,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWidgetOpen]);

  // refresh the Progress Note widget by updating the key, no API call
  useEffect(() => {
    if (refreshPN) {
      setRefreshNotes(refreshNotes + 1);
      // reset GLOBAL CONTEXT
      globalContext.dispatch({
        type: REFRESH_PN_WIDGET,
        payload: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPN]);

  /* generic widget callback implementation */
  const onWidgetReady = (widgetName: mumms.ComponentName) => {
    if (widgetName) {
      if (dispatch) {
        dispatch({
          type: ADD_WIDGET_READY,
          payload: widgetName,
        });
      }
    }
  };
  /**
   * Forms Widget needs a state variable outside of the current instance.
   * This applies when there is a couch/pouch error in forms. If the user clicks another
   * form after the first form threw an error, the error message is still displayed on
   * subsequent forms until the user refreshes the browser.
   */
  const [showForms, setShowForms] = useState<boolean>(true);

  // height 320 and width 496 for 1*1 widgets
  const gridRowHeight = widget1by1Height / 2;

  const columns = {
    xl: 8,
    lg: 6,
    md: 4,
    sm: 4,
    /* Single column below `sm` so narrow iframes (e.g. embedded SmartChart) get full-width tiles */
    xs: 1,
    xxs: 1,
  };

  const breakpoints = {
    xl: 1700,
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0,
  };

  const openWidget = (widget: mumms.WidgetConfig) => {
    // hack as issue with idg meeting
    if (
      (widgetsOpen.length === 1 &&
        widgetsOpen[0].componentName === idgMeetingName) ||
      !isWidgetOpen
    ) {
      globalContext.dispatch({
        type: OPEN_WIDGET,
        payload: widget,
      });
    } else {
      globalContext.dispatch({
        type: CLOSE_WIDGET,
        payload: widget,
      });
      if (widget.componentName === MeasuresWidget) {
        setRefreshMeasures(refreshMeasure + 1);
      }
      if (widget.componentName === DocLinkWidget) {
        setRefreshCert(refreshCert + 1);
      }
      if (widget.componentName === CarePlanFrequencyWidget) {
        setRefreshVisit(refreshVisit + 1);
      }
      if (widget.componentName === ClearScriptsWidget) {
        setRefreshMeds(refreshMeds + 1);
        // EA owed status depends on non-covered meds; refresh header on close.
        if (patientNumber) {
          refreshGlobalPatientHeader(
            pim,
            globalContext.dispatch,
            patientNumber,
            agency || undefined,
          );
        }
      }
      if (widget.componentName === HospiceItemSetWidget) {
        setRefreshHIS(refreshHIS + 1);
      }
      if (widget.componentName === ProgressNotesWidget) {
        setRefreshNotes(refreshNotes + 1);
      }
      if (widget.componentName === CarePlanProblemsWidget) {
        setRefreshPlans(refreshPlans + 1);
      }
    }
  };
  // look at patient and user
  const isReadOnly = currentUser.readOnly || patient?.readOnly;
  // NOTE key is a hack because of https://github.com/highcharts/highcharts/issues/6427
  useEffect(() => {
    if (
      isWidgetOpen &&
      widgetsOpen.length &&
      widgetNamesOpen.includes(MeasuresWidget as mumms.ComponentName)
    ) {
      setRefreshMeasures(refreshMeasure + 1);
    }
  }, [widgetsOpen.length]);

  const getComponent = ({
    name,
    order,
    title,
    height,
    width,
    w,
    h,
    beta,
    watermark,
    onClick,
    onRemove,
    doNotShow,
    smallWidget,
    view,
  }: mumms.GetCompProps) =>
    Map[name] &&
    (Map[name] as any)({
      order,
      name,
      title,
      height,
      width,
      w,
      h,
      beta,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
      view,
    });

  const certKey = `DocLinkStatic${refreshDashboard}${refreshCert}`;

  const Map: ComponentMap = {
    DocLink: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      // TODO REFACTOR CERT_APP
      <DocLinkWidgetWrapper id="doc-link-wrap">
        <WidgetHeader
          appTitle={title || 'Certifications'}
          versionInfo={`DocLink v${process.env.REACT_APP_CERT_APP_VERSION}, SmartChart v${process.env.REACT_APP_VERSION}`}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          smallWidget={smallWidget}
        />
        <DocLinkBody smallWidget={smallWidget} id="body-wrap">
          {watermark && watermark.show ? (
            <Watermark
              readOnly={watermark.readOnly}
              smallWidget={smallWidget}
            />
          ) : null}

          <DocLinkWidgetScroll id="scroll-wrap" smallWidget={smallWidget}>
            <CertApp
              embedded
              smallWidget={smallWidget}
              pim={pim}
              agency={agency || undefined}
              dateFrom={undefined}
              dateTo={undefined}
              keycloak={keycloak}
              logout={logout}
              patientNumber={patientNumber}
              viewMode="small"
              theme={theme as string}
              key={certKey}
              onWidgetReady={onWidgetReady}
            />
          </DocLinkWidgetScroll>
        </DocLinkBody>
      </DocLinkWidgetWrapper>
    ),
    CarePlanFrequency: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const visitFreqKey = `CarePlanFrequencyStatic${refreshDashboard}${refreshVisit}`;
      return (
        <ErrorBoundary>
          <CarePlanFrequency
            embedded
            online
            appTitle={title}
            agency={agency || undefined}
            currentUser={currentUser}
            keycloak={keycloak}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            patient={patient}
            patientNumber={patientNumber}
            // TODO fix agency issue for admin
            // pim={pim}
            smallWidget={smallWidget}
            view={undefined}
            watermark={watermark}
            theme={theme as string}
            key={visitFreqKey}
            siteId={siteId}
            onWidgetReady={onWidgetReady}
            readOnly={isReadOnly}
          />
        </ErrorBoundary>
      );
    },
    // Opened only from the CPVF Compliance View button (not in any layout);
    // it shows expanded beside CPVF and its checkmark closes it.
    ComplianceView: ({ title, onClick }: mumms.MapProps) => (
      <ErrorBoundary>
        <ScheduledVisits
          embedded
          online
          smallWidget={false}
          appTitle={title}
          currentUser={currentUser}
          keycloak={keycloak}
          patient={patient}
          patientNumber={patientNumber}
          agency={agency}
          view={undefined}
          onClick={onClick}
          theme={theme as string}
          key={`ComplianceView${refreshDashboard}${refreshVisit}`}
        />
      </ErrorBoundary>
    ),
    ClearScripts: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const medsKey = `ClearScriptsStatic${refreshDashboard}${refreshMeds}`;
      return (
        <ErrorBoundary>
          <ClearScripts
            // dashboardEmbedded because Meds is in DocLink and Dashboard
            dashboardEmbedded
            embedded
            online
            hideActionBar
            smallWidget={smallWidget}
            readonly={smallWidget || isReadOnly}
            appTitle={title}
            agency={agency || undefined}
            currentUser={currentUser}
            keycloak={keycloak}
            logout={logout}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            patient={patient}
            patientNumber={patientNumber}
            viewMode="small"
            watermark={watermark}
            theme={theme as string}
            key={medsKey}
            siteId={siteId}
            onWidgetReady={onWidgetReady}
          />
        </ErrorBoundary>
      );
    },
    Facesheet: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <Facesheet
          online
          smallWidget={smallWidget}
          appTitle={title as string}
          agency={agency}
          keycloak={keycloak}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          patientNumber={patientNumber}
          watermark={watermark}
          theme={theme as string}
          onWidgetReady={onWidgetReady}
        />
      </ErrorBoundary>
    ),
    Forms: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <Forms
          embedded
          smallWidget={smallWidget}
          appTitle={title as string}
          agency={agency}
          currentUser={currentUser}
          keycloak={keycloak}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          patientNumber={patientNumber}
          patient={patient}
          // TODO fix agency issue for admin
          // pim={pim}
          watermark={watermark}
          theme={theme as string}
          key={key}
          database={database}
          showForms={showForms}
          setShowForms={setShowForms}
          onWidgetReady={onWidgetReady}
          siteId={siteId}
        />
      </ErrorBoundary>
    ),
    Manifest: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
      view,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <Manifest
          embedded
          smallWidget={smallWidget}
          appTitle={title as string}
          agency={agency}
          keycloak={keycloak}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          patientNumber={patientNumber}
          currentUser={currentUser}
          patient={patient}
          watermark={watermark}
          theme={theme as string}
          key={`${key}-${reloadManifest}`}
          onWidgetReady={onWidgetReady}
          siteId={siteId}
          view={view as any}
        />
      </ErrorBoundary>
    ),
    Measures: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const measuresKey = `MeasuresStatic${refreshDashboard}${refreshMeasure}`;
      return (
        <ErrorBoundary>
          <Measures
            embedded
            smallWidget={smallWidget}
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            patient={patient}
            patientNumber={patientNumber}
            // TODO fix agency issue for admin
            // pim={pim}
            watermark={watermark}
            theme={theme as string}
            key={measuresKey}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
            readOnly={isReadOnly}
          />
        </ErrorBoundary>
      );
    },
    HospiceItemSet: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const hisKey = `HISStatic${refreshDashboard}${refreshHIS}`;
      return (
        <ErrorBoundary>
          <HospiceItemSet
            embedded
            online
            smallWidget={smallWidget}
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            // TODO fix agency issue for admin
            // pim={pim}
            watermark={watermark}
            theme={theme as string}
            key={hisKey}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
          />
        </ErrorBoundary>
      );
    },
    Hope: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <Hope
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency}
          currentUser={currentUser}
          keycloak={keycloak}
          patient={patient}
          patientNumber={patientNumber}
          // TODO fix agency issue for admin
          // pim={pim}
          watermark={watermark}
          theme={theme as string}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          onWidgetReady={onWidgetReady}
          siteId={siteId}
          readOnly={isReadOnly}
          hasExternalHopeGlobalContext
        />
      </ErrorBoundary>
    ),
    ProgressNotes: ({
      name,
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
      view,
    }: mumms.MapProps) => {
      const online = navigator.onLine;
      const filter =
        widgetsFilter && widgetsFilter[name as mumms.ComponentName];
      // if smallWidget no Filter on
      const showFilter = !smallWidget && filter;
      const appendToOrder = !!(showFilter && filter.appendToOrder);
      const noteKey = `ProgressNotesStatic${refreshDashboard}${refreshNotes}${idgFilter}`;
      // todo title in translation files
      return (
        <ErrorBoundary>
          <ProgressNotes
            online={online}
            agency={agency || undefined}
            currentUser={currentUser}
            appTitle={
              appendToOrder
                ? `Addendum to ${
                    filter.ordertypename || filter.entityName || ''
                  }`
                : showFilter
                ? filter.entityName
                : title
            }
            embedded
            // TODO fix agency issue for admin -
            // pim={pim}
            keycloak={keycloak}
            patient={patient}
            patientNumber={
              showFilter && !patientNumber
                ? filter.patientNumber
                : patientNumber
            }
            watermark={watermark}
            smallWidget={smallWidget}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            theme={theme as string}
            entityType={
              appendToOrder
                ? null
                : idgFilter && !filter
                ? 'IDG'
                : showFilter
                ? filter.entityType
                : null
            }
            entityKey={
              appendToOrder
                ? null
                : idgFilter && !filter
                ? `-1_${isIDGMeeting}`
                : showFilter
                ? filter.entityKey
                : null
            }
            entityName={
              appendToOrder ? null : showFilter ? filter.entityName : null
            }
            showFilter={showFilter && !appendToOrder}
            appendToOrder={appendToOrder}
            appendOrder={
              appendToOrder
                ? {
                    progressNoteId: filter.progressNoteId,
                    ordertypeshortname: filter.ordertypeshortname,
                    isorder: filter.isorder,
                    patientNumber: filter.patientNumber,
                    ordertypename: filter.ordertypename,
                    orderNoteText: filter.orderNoteText,
                    orderSigned: filter.orderSigned,
                    ordernotecount: filter.ordernotecount,
                  }
                : null
            }
            key={noteKey}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
            // set for MANIFEST
            view={filter ? filter.view : view}
            intl={intl}
            admitHopePatient={admitHopePatient}
            readOnly={isReadOnly}
            idgMeetingId={idgMeetingId}
          />
        </ErrorBoundary>
      );
    },
    PatientsListing: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <PatientsListing
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency}
          currentUser={currentUser}
          keycloak={keycloak}
          // pim={pim}
          watermark={watermark}
          theme={theme as string}
          key={key}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          onWidgetReady={onWidgetReady}
          siteId={siteId}
        />
      </ErrorBoundary>
    ),
    PatientAssistance: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <PatientAssistance
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency}
          currentUser={currentUser}
          patient={patient}
          patientNumber={patientNumber}
          keycloak={keycloak}
          // pim={pim}
          watermark={watermark}
          theme={theme as string}
          key={key}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          siteId={siteId}
          onWidgetReady={onWidgetReady}
        />
      </ErrorBoundary>
    ),
    VisitLog: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
      view,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <VisitLog
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency}
          currentUser={currentUser}
          patient={patient}
          patientNumber={patientNumber}
          visitAttributes={visitAttributes}
          keycloak={keycloak}
          pim={pim}
          watermark={watermark}
          theme={theme as string}
          key={key}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          siteId={siteId}
          onWidgetReady={onWidgetReady}
          view={view}
          readOnly={isReadOnly}
          hydrateInProgressVisitFromLog={hydrateInProgressVisitFromLog}
          hydrateDocumentVisitFromLog={hydrateDocumentVisitFromLog}
          setReopenVisitDashboardLoader={setReopenVisitDashboardLoader}
        />
      </ErrorBoundary>
    ),
    VisitSummary: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <VisitSummary
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency}
          currentUser={currentUser}
          patient={patient}
          patientNumber={patientNumber}
          visitAttributes={visitAttributes}
          keycloak={keycloak}
          pim={pim}
          watermark={watermark}
          theme={theme as string}
          key={key}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          siteId={siteId}
          onWidgetReady={onWidgetReady}
        />
      </ErrorBoundary>
    ),
    Orders: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <Orders
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency}
          currentUser={currentUser}
          patient={patient}
          patientNumber={patientNumber}
          keycloak={keycloak}
          // pim={pim}
          watermark={watermark}
          theme={theme as string}
          key={key}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          siteId={siteId}
          onWidgetReady={onWidgetReady}
        />
      </ErrorBoundary>
    ),
    PortalPrint: ({
      title,
      smallWidget,
      onRemove,
      doNotShow,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <PortalPrint
          embedded
          smallWidget={smallWidget}
          appTitle={title}
          theme={theme as string}
          key={key}
          onRemove={onRemove}
          doNotShow={doNotShow}
          onWidgetReady={onWidgetReady}
          onPrintClick={openPrintInterface}
          printWidgetNames={printConfigNames}
        />
      </ErrorBoundary>
    ),
    Incidents: ({
      title,
      smallWidget,
      onClick,
      onRemove,
      doNotShow,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <IncidentsWidget
          embedded
          smallWidget={smallWidget}
          appTitle={title}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          theme={theme}
          key={key}
          onWidgetReady={onWidgetReady}
          patient={patient}
          agency={agency}
          currentUser={currentUser}
          keycloak={keycloak}
          siteId={siteId}
          patientNumber={patientNumber}
        />
      </ErrorBoundary>
    ),
    FaxLog: ({
      title,
      watermark,
      onClick,
      smallWidget,
      onRemove,
      doNotShow,
    }: mumms.MapProps) => {
      const faxLogKey = `FaxLogStatic${refreshDashboard}${refreshPlans}`;
      return (
        <ErrorBoundary>
          <FaxLog
            online
            agency={agency || undefined}
            currentUser={currentUser}
            appTitle={title}
            embedded
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            watermark={watermark}
            smallWidget={smallWidget}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            theme={theme as string}
            key={faxLogKey}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
            readOnly={isReadOnly}
          />
        </ErrorBoundary>
      );
    },
    MAIAChatAgent: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <MaiaChatAgent
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency || undefined}
          currentUser={currentUser}
          keycloak={keycloak}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          patient={patient}
          patientNumber={patientNumber}
          watermark={watermark}
          theme={theme as string}
          onWidgetReady={onWidgetReady}
          siteId={siteId != null ? siteId.toString() : undefined}
          readOnly={isReadOnly}
        />
      </ErrorBoundary>
    ),
    Bereavement: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <Bereavement
          embedded
          online
          smallWidget={smallWidget}
          appTitle={title}
          agency={agency}
          currentUser={currentUser}
          patient={patient}
          patientNumber={patientNumber}
          keycloak={keycloak}
          // pim={pim}
          watermark={watermark}
          theme={theme as string}
          key={key}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          siteId={siteId}
          onWidgetReady={onWidgetReady}
          readOnly={isReadOnly}
        />
      </ErrorBoundary>
    ),
    CarePlanProblems: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const cppKey = `CarePlanProblemsStatic${refreshDashboard}${refreshPlans}`;
      return (
        <ErrorBoundary>
          <CarePlanProblems
            agency={agency || undefined}
            currentUser={currentUser}
            appTitle={title}
            embedded
            // pim={pim}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            watermark={watermark}
            smallWidget={smallWidget}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            theme={theme as string}
            key={cppKey}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
            readOnly={isReadOnly}
          />
        </ErrorBoundary>
      );
    },
    IDGDocument: ({
      name,
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      // todo title in translation files
      <ErrorBoundary>
        <IDGDocument
          online
          agency={agency || undefined}
          currentUser={currentUser}
          appTitle={title}
          embedded
          // TODO fix agency issue for admin -
          // pim={pim}
          keycloak={keycloak}
          patient={patient}
          patientNumber={patientNumber}
          printConfig={dashboardPrintConfig as any}
          printConfigNames={printConfigNames}
          watermark={watermark}
          smallWidget={smallWidget}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          theme={theme as string}
        />
      </ErrorBoundary>
    ),
    // OP-33263: clinical dashboard table of patients who missed planned visits.
    ComplianceCrossPatient: ({
      title,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <CrossPatientCompliance
          embedded
          online
          agency={agency || undefined}
          siteId={siteId}
          currentUser={currentUser}
          appTitle={title}
          keycloak={keycloak}
          pim={pim}
          smallWidget={smallWidget}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          onWidgetReady={onWidgetReady}
          theme={theme as string}
          key={`ComplianceCrossPatient${refreshDashboard}`}
        />
      </ErrorBoundary>
    ),
    IDGCrossPatient: ({
      title,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => (
      <ErrorBoundary>
        <CrossPatientIDG
          embedded
          agency={agency || undefined}
          siteId={siteId}
          currentUser={currentUser}
          appTitle={title}
          keycloak={keycloak}
          pim={pim}
          smallWidget={smallWidget}
          onClick={onClick}
          onRemove={onRemove}
          doNotShow={doNotShow}
          onWidgetReady={onWidgetReady}
          theme={theme as string}
        />
      </ErrorBoundary>
    ),
    CompletedForms: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const cfKey = `CompletedFormsStatic${refreshDashboard}${refreshPlans}`;
      return (
        <ErrorBoundary>
          <CompletedForms
            online
            agency={agency || undefined}
            currentUser={currentUser}
            appTitle={title}
            embedded
            // pim={pim}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            watermark={watermark}
            smallWidget={smallWidget}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            theme={theme as string}
            key={cfKey}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
            readOnly={isReadOnly}
          />
        </ErrorBoundary>
      );
    },
    ReportsList: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const cfKey = `ReportsListStatic${refreshDashboard}${refreshPlans}`;
      return (
        <ErrorBoundary>
          <ReportsList
            embedded
            online
            smallWidget={smallWidget}
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            watermark={watermark}
            theme={theme as string}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
          />
        </ErrorBoundary>
      );
    },
    FinancialReports: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const cfKey = `ReportsListStatic${refreshDashboard}${refreshPlans}`;
      return (
        <ErrorBoundary>
          <ReportsList
            embedded
            online
            reportsListGroup="Finance"
            smallWidget={smallWidget}
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            watermark={watermark}
            theme={theme as string}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
          />
        </ErrorBoundary>
      );
    },
    DemographicReports: ({
      title,
      watermark,
      onClick,
      onRemove,
      doNotShow,
      smallWidget,
    }: mumms.MapProps) => {
      const cfKey = `ReportsListStatic${refreshDashboard}${refreshPlans}`;
      return (
        <ErrorBoundary>
          <ReportsList
            embedded
            online
            reportsListGroup="Demographics"
            smallWidget={smallWidget}
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            watermark={watermark}
            theme={theme as string}
            onClick={onClick}
            onRemove={onRemove}
            doNotShow={doNotShow}
            onWidgetReady={onWidgetReady}
            siteId={siteId}
          />
        </ErrorBoundary>
      );
    },
  };

  const generateGrid = (widgetconfig: mumms.WidgetConfig[]) =>
    widgetconfig.map(
      (widget: mumms.WidgetConfig) =>
        widget.widgetMenuOrder != null && (
          <div
            key={widget.widgetMenuOrder ?? widget.widgetName}
            style={widget.hidden ? { display: 'none' } : {}}
          >
            {getComponent({
              order: String(widget.widgetMenuOrder),
              name: widget.componentName,
              title: widget.widgetName,
              beta: widget.beta,
              watermark: widget.watermark,
              onClick: () => openWidget(widget),
              onRemove: onRemovePatientDashboardWidget
                ? () => onRemovePatientDashboardWidget(widget)
                : undefined,
              doNotShow: widget.doNotShow,
              smallWidget: true,
              view: (widget as any).view,
            })}
          </div>
        ),
    );

  // there is two call to dashboard when widget is open
  // building dashboard in background and widget open
  // that is why we have 2 set of API calls when opening a widget
  const getWidgetOpen = (widgets: mumms.WidgetConfig[]) => {
    if (widgets.length) {
      return widgets.map((widget: any, index: number) => (
        <WidgetModal
          key={widget.widgetMenuOrder ?? widget.widgetName}
          numberOpen={widgets.length}
          topBarHeight={topBarHeight}
          name={widget.componentName}
          index={index}
          className="widget-modal"
        >
          {getComponent({
            order: String(widget.widgetMenuOrder),
            name: widget.componentName,
            title: widget.widgetName,
            beta: widget.beta,
            watermark: widget.watermark,
            onClick: () => openWidget(widget),
            view: widget.view,
            smallWidget: false,
          })}
        </WidgetModal>
      ));
    }
    return null;
  };

  const generateLayoutSize = (size: mumms.Size) => {
    const layout: Layout[] = widgetsConfig.map((widget: mumms.WidgetConfig) => {
      const { widgetMenuOrder } = widget;
      const i = String(widgetMenuOrder ?? '');
      const w = DEFAULT_GRID_W;
      const h = DEFAULT_GRID_H;

      /* eslint-disable indent */
      const column = columns[size];
      return {
        x: (Number(widgetMenuOrder) * 2) % column,
        y: Math.floor(Number(widgetMenuOrder) / (column / 2)) * 2,
        w,
        h,
        i,
      };
    });
    return layout;
  };

  /** Full-width stacked tiles for xs/xxs (narrow viewport or embedded iframe). */
  const generateSingleColumnLayout = (): Layout[] => {
    const sorted = [...widgetsConfig].sort(
      (a, b) =>
        (a.widgetMenuOrder ?? Number.POSITIVE_INFINITY) -
        (b.widgetMenuOrder ?? Number.POSITIVE_INFINITY),
    );
    let y = 0;
    return sorted.map((widget: mumms.WidgetConfig) => {
      const i = String(widget.widgetMenuOrder ?? '');
      const h = DEFAULT_GRID_H;
      const item = {
        x: 0,
        y,
        w: 1,
        h,
        i,
      };
      y += h;
      return item;
    });
  };

  const generateLayouts = (): Layouts => {
    const layouts: Layouts = {
      lg: generateLayoutSize('lg'),
      xl: generateLayoutSize('xl'),
      md: generateLayoutSize('md'),
      sm: generateLayoutSize('sm'),
      xs: generateSingleColumnLayout(),
      xxs: generateSingleColumnLayout(),
    };
    return layouts;
  };

  const onLayoutChange = (layout: any, layouts: any) => {
    // TODO gridConfig the the component name, see how to integrate both
    // localStorage.setItem(WIDGET_CONFIG, JSON.stringify(layout));
    // setStoredWidgetsConfig(layout);
    // NOTE: see if easier rendering
  };

  const onBreakpointChange = (breakpoint: any) => {
    // NOTE: see diff with fixed width
  };

  // TODO Note: there are 2 compactType: see algorithm, "vertical" | "horizontal"

  const fromDate = dashboardPrintConfig && dashboardPrintConfig.fromDate;
  const toDate = dashboardPrintConfig && dashboardPrintConfig.toDate;
  /*
      Converted the fromDate and twoDate back to strings.  The MM-DD-YYYY
      is required for observation service to process the incoming request. 
    */
  const printDateConfig: any =
    fromDate && toDate
      ? {
          fromDate: moment(fromDate[0]).format('MM-DD-YYYY'),
          toDate: moment(toDate[0]).format('MM-DD-YYYY'),
        }
      : {};

  const printConfigState = Object.entries({
    ...dashboardPrintConfig,
  }).reduce((seed: any, printWidget: any) => {
    const name = printWidget[0];
    const pConfig = printWidget[1];
    const printConfig =
      typeof config === 'boolean'
        ? printDateConfig
        : { ...printDateConfig, ...pConfig };
    seed[name] = printConfig;
    return seed;
  }, {});

  useEffect(() => {
    // if no certifications exist for a patient: let ReactPDF know
    if (includePdfCertApp === STRING_TRUE && !patientCertHistory) {
      dispatchReactPDF({
        type: SET_PDF_CERT_APP_SNAPSHOT,
        payload: { snapshotProcessed: STRING_TRUE, snapshot: [] },
      });
    }
  }, [includePdfCertApp, patientCertHistory]);

  return (
    <React.Fragment>
      <ResponsiveGridLayout
        className="layout"
        rowHeight={gridRowHeight}
        layouts={generateLayouts()}
        onLayoutChange={onLayoutChange}
        onBreakpointChange={onBreakpointChange}
        isResizable={false}
        isDraggable={false}
        breakpoints={breakpoints}
        cols={columns}
        margin={[5, 5]}
        compactType="horizontal"
        containerPadding={[5, 5]}
      >
        {generateGrid(widgetsConfig)}
      </ResponsiveGridLayout>
      {/* show as long as any widget is open */}
      <ModalDiv className="modal-div" show={isWidgetOpen}>
        {getWidgetOpen(widgetsOpen)}
      </ModalDiv>
      {includePdfCertApp === STRING_TRUE && patientCertHistory && (
        <ReactPDFWrapper reactPdfView>
          <CertApp
            agency={agency || undefined}
            keycloak={keycloak}
            patientNumber={patientNumber}
            viewMode={print}
            key={dashboardPrintConfig ? DocLink : print}
            printConfig={printConfigState.DocLink}
          />
        </ReactPDFWrapper>
      )}
    </React.Fragment>
  );
};
export default DashboardGridComponent;
